import React from 'react'
import imageCaseACocherCroix from '../../../images/caseACocherCroix.png'
import imageCaseACocherOk from '../../../images/caseACocherOk.png'

const AllowClient = ({ _allowBooking, allowBooking, keyUid, id }) => {
    return (
        <div className='row shadow mt-3 pb-2'>

            <div className='text-center'>
                    <div className='d-inline-flex'>
                        <div 
                            onClick={() => _allowBooking(allowBooking, keyUid, id)}
                        >
                            {allowBooking === false ? 
                                <img src={imageCaseACocherOk} alt='image case a cocher' style={{ height:25, width:25 }}  />
                            : 
                                <img src={imageCaseACocherCroix} alt='image case a cocher' style={{ height:25, width:25,  }} />
                            } 
                        </div>
                        <div style={{ marginTop:'0.3rem', marginLeft:'1rem' }}>{allowBooking === false ? 'Réservation autorisée' : 'Réservation interdite'}</div>
                    </div>
            </div>
 
        </div>
    )
}

export default AllowClient





